import { useCallback } from 'react';

export function useParameterRemove<T>(
  onRemoveParameter: ((option: T) => void) | undefined,
  onRemoveClick: (() => void) | undefined
) {
  return useCallback(
    (option: T) => {
      if (onRemoveParameter) {
        return () => onRemoveParameter(option);
      }
      return onRemoveClick;
    },
    [onRemoveParameter, onRemoveClick]
  );
}
